/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ when: NonNullable<unknown> }} Canvas_Domain_Status_LiveInputs */



/**
* | output |
* | --- |
* | "Live. Last verified {when}." |
*
* @param {Canvas_Domain_Status_LiveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_domain_status_live = /** @type {((inputs: Canvas_Domain_Status_LiveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Domain_Status_LiveInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Online. Zuletzt geprüft am ${i?.when}.`)
	return /** @type {LocalizedString} */ (`Live. Last verified ${i?.when}.`)
});